export const PAYMENT_INITIATE_REQUEST = "PAYMENT_INITIATE_REQUEST"
export const PAYMENT_INITIATE_SUCCESS = "PAYMENT_INITIATE_SUCCESS"
export const PAYMENT_INITIATE_FAIL = "PAYMENT_INITIATE_FAIL"

export const PAYMENT_VERIFY_REQUEST = "PAYMENT_VERIFY_REQUEST"
export const PAYMENT_VERIFY_SUCCESS = "PAYMENT_VERIFY_SUCCESS"
export const PAYMENT_VERIFY_FAIL = "PAYMENT_VERIFY_FAIL"

export const SUBSCRIPTION_CANCEL_REQUEST = "SUBSCRIPTION_CANCEL_REQUEST"
export const SUBSCRIPTION_CANCEL_SUCCESS = "SUBSCRIPTION_CANCEL_SUCCESS"
export const SUBSCRIPTION_CANCEL_FAIL = "SUBSCRIPTION_CANCEL_FAIL"

export const SUBSCRIPTION_PAUSE_REQUEST = "SUBSCRIPTION_PAUSE_REQUEST"
export const SUBSCRIPTION_PAUSE_SUCCESS = "SUBSCRIPTION_PAUSE_SUCCESS"
export const SUBSCRIPTION_PAUSE_FAIL = "SUBSCRIPTION_PAUSE_FAIL"

export const SUBSCRIPTION_RESUME_REQUEST = "SUBSCRIPTION_RESUME_REQUEST"
export const SUBSCRIPTION_RESUME_SUCCESS = "SUBSCRIPTION_RESUME_SUCCESS"
export const SUBSCRIPTION_RESUME_FAIL = "SUBSCRIPTION_RESUME_FAIL"